import { Component, Inject } from '@angular/core';
import { APP_CONFIG, AppConfig } from '../../../../app.config';


@Component({
    selector: 'app-footer-image',
    imports: [],
    templateUrl: './footer-image.component.html',
    styleUrls: ['./footer-image.component.scss']
})
export class FooterImageComponent {
    isPsicTheme: boolean = false;
    selectedTheme: string = this.config.theme;
    constructor(@Inject(APP_CONFIG) private config: AppConfig) {
        if (localStorage.getItem('selectedTheme') && !this.config.production) {
            this.selectedTheme = localStorage.getItem('selectedTheme')!;
        }
        if(this.selectedTheme === 'psic'){
            this.isPsicTheme = true;
        }
    }
}
